import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { ModalService, ConfirmationModalComponent } from './../../../shared/modules/modal';
import {
  ClosableModalWithErrorResponse
} from './../../../shared/components/base/closable-modal-with-error-response-model';

import {
  PbaTransaction,
  Currency,
  Message,
  AddPbaTransactionPayload,
  PbaTransactionsModalPayload,
  Transaction
} from './../../../shared/models';
import { PaginationConstants, TranslationConstants } from '../../../shared/constants';

import { PbasService, SessionService, UtilsService, NotificationService } from './../../../shared/services';

@Component({
  selector: 'add-transactions-modal',
  templateUrl: './add-transactions-modal.component.html',
})
export class AddTransactionsModalComponent
  extends ClosableModalWithErrorResponse
  implements OnInit, OnDestroy {
  data: PbaTransactionsModalPayload;
  transactions: PbaTransaction[] = [];
  upeCurrency: Currency;
  noSuitableTransactionsMessage: string = TranslationConstants.NO_SUITABLE_TRANSACTIONS;

  pendingSelectedTransaction: PbaTransaction;

  pageSizes: number[];
  currentPage = 1;
  totalItems: number;
  selectedPageSize = PaginationConstants.DEFAULT_PAGE_SIZE;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _pbasService: PbasService,
    private _utilsService: UtilsService,
    private _sessionService: SessionService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.upeCurrency = this._sessionService.getContainerUpeCurrency();
    this.pageSizes = PaginationConstants.PAGE_SIZES;
    this.getSuitableTransactions();
    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.getSuitableTransactions();
  }

  pageSizeChanged(): void {
    this.getSuitableTransactions();
  }

  save(closeModal = true): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.responseErrors = [];
    if (!this.pendingSelectedTransaction) {
      this.closeAllModals();
      return;
    }

    const payload = this.getPayloadForSave();
    this._pbasService.addTransaction(this.data.pba.pbaId, payload).subscribe(() => {
      if (closeModal) {
        this.closeAllModals();
      } else {
        this.pendingSelectedTransaction = null;
        this.getSuitableTransactions();
        this.isSaveDisabled = false;
      }
      this.success();
    });
  }

  getEntityCode(transaction: PbaTransaction, isSource = true): string {
    return this._utilsService.getEntityCodeFromTransaction(transaction, isSource);
  }

  // override
  close(): void {
    if (!!this.pendingSelectedTransaction) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: TranslationConstants.MODAL_TITLE_CLOSE_ADD_TRANSACTIONS,
          content: TranslationConstants.GLOBAL_CANCEL_MODAL_MESSAGE,
        } as Message,
        success: () => {
          this.closeAllModals();
        },
      });
    } else {
      this.closeAllModals();
    }
  }

  // override
  protected handleErrors(res: HttpErrorResponse): void {
    if (res.status === 400) {
      // this.responseErrors.push(res.error.errors.global);
    } else if (res.status === 422) {
      const transactionIdsErrors = Object.keys(res.error.errors).filter(key => key.includes('transactionId'));
      if (transactionIdsErrors.length > 0) {
        this.responseErrors.push(TranslationConstants.ERROR_PBA_TRANSACTION_ID);
      }
    } else {
      // this.responseErrors.push(TranslationConstants.GLOBAL_SERVER_ERROR);
    }
  }

  protected getFormatedDate(transaction: Transaction): string {
    return this._utilsService.getFormatedTransactionDate(transaction);
  }

  private getPaginationQueryString(): string {
    return this._utilsService.getPaginationQueryString(this.selectedPageSize, this.currentPage);
  }

  private getSuitableTransactions(): void {
    this.resetErrors();
    this._pbasService.listSuitableTransactions(this.data.pba.pbaId, `?${this.getPaginationQueryString()}`)
      .subscribe(({ data, count }) => {
        this.transactions = data;
        this.totalItems = count;
        this._utilsService.setDatesForTransactions(this.transactions);
      });
  }

  private getPayloadForSave(): AddPbaTransactionPayload {
    const payload = new AddPbaTransactionPayload();
    payload.transactionId = this.pendingSelectedTransaction.transactionId;

    return payload;
  }

}
